import type { ReactNode } from 'react';
import { BaseDialog } from '@/common/components/base-dialog/BaseDialog';

interface MultiValueListDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  children: ReactNode;
}

export const MultiValueListDialog = ({
  open,
  onOpenChange,
  title,
  children,
}: MultiValueListDialogProps) => (
  <BaseDialog open={open} onOpenChange={onOpenChange} title={title} showCloseButton size="sm">
    <div className="flex flex-col gap-2 overflow-y-auto py-2">{children}</div>
  </BaseDialog>
);
